import { Injectable, Type } from '@angular/core';
import { BehaviorSubject, Observable, take } from 'rxjs';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ModalShellComponent } from '@d-components/modal-shell/modal-shell.component';
import { ManageModal, ModalSize } from '@d-constants';

interface IParamsModal {
  title?: string | { key: string; params: object };
  size?: ModalSize;
  height?: string;
  width?: string;
  [key: string]: any;
  data?: any;
  manage?: ManageModal;
  showIconClose?: boolean;
}

@Injectable({ providedIn: 'root' })
export class ModalService {
  private currentDialogRef: DynamicDialogRef[] = [];
  private _currentComponentRef: any[] = [];

  get currentComponentRef() {
    return this._currentComponentRef[this._currentComponentRef.length - 1];
  }

  get _currentDialogRef() {
    return this.currentDialogRef;
  }

  set currentComponentRef(comp) {
    this._currentComponentRef.push(comp);
  }

  showLoading$ = new BehaviorSubject(0);
  constructor(private dialogService: DialogService) {}

  /**
   * NOTICE: If you want handle something after close dialg, you can subscribe this function
   * @param component component will appear in dialog
   * @param params any params you want input to component
   * @returns a dialog will appear
   */
  openModal<T>(
    component: Type<T> | string,
    params?: IParamsModal,
  ): Observable<any> {
    const dialogRef = this.dialogService.open(ModalShellComponent, {
      showHeader: false,
      data: params?.data,
      style: params?.manage,
      height: params?.height,
      width: params?.width,
    });
    this.currentComponentRef = { component, params };
    this.currentDialogRef.push(dialogRef);
    return this.currentDialogRef[this.currentDialogRef.length - 1].onClose.pipe(
      take(1),
    );
  }

  /**
   * NOTICE: If you want handle something after close dialog, please add params for this function and subscribe openDialog function
   * @param param any thing you want to handle after close Dialg
   */
  closeModal(param?: any) {
    const lastDialogRef =
      this.currentDialogRef[this.currentDialogRef.length - 1];
    this.currentDialogRef.pop();
    this._currentComponentRef.pop();
    lastDialogRef.close(param);
  }

  closeAllModal(result?: any) {
    this.currentDialogRef.forEach((item) => {
      item.close(result);
    });
  }

  showLoading() {
    this.showLoading$.next(this.showLoading$.value + 1);
  }

  hideLoading() {
    this.showLoading$.next(
      this.showLoading$.value > 0 ? this.showLoading$.value - 1 : 0,
    );
  }

  onKeydown(event: any) {
    if (event.which === 13 || event.which === 32) {
      event.preventDefault();
    }
  }
}
